import React from "react";
import { Redirect, Route, RouteComponentProps, Switch } from "react-router-dom";
import Page404 from "go-app/components/Page404/Page404";
import AdminReportsNavigation from "./components/AdminReportsNavigation";
import AdminAccessReportPage from "./pages/AccessReport/pages/Index";
import AdminReportsComboPage from "./pages/Combo";
import AdminCompaniesReportPage from "./pages/CompaniesReport/pages/Index";
import CrashReportsPage from "./pages/CrashReports";
import AdminDashboardPage from "./pages/Dashboard";
import AdminDeviceReportPage from "./pages/DevicesReport";
import AdminOrganizationFeatureReportPage from "./pages/OrganizationFeatureReport/pages/Index";
import AdminOrganizationFeatureUsageReportPage from "./pages/OrganizationFeatureReport/pages/Usage";
import AdminOrganizationReportPage from "./pages/OrganizationReport";
import AdminPartnerReportPage from "./pages/PartnerReport";
import AdminTerminalReportPage from "./pages/TerminalsReport";
import AdminTransactionsReportPage from "./pages/TransactionsReport/pages/Index";

const AdminReportsPage = (props: RouteComponentProps) => {
	return (
		<>
			<div className="page-container">
				<AdminReportsNavigation match={props.match} history={props.history} location={props.location} />
				<Switch>
					<Route exact path={`${props.match.url}/`}>
						<Redirect to={`${props.match.url}/combo_reports`} />
					</Route>
					<Route path={`${props.match.url}/combo_reports`} component={AdminReportsComboPage} />
					<Route path={`${props.match.url}/crash_reports`} component={CrashReportsPage} />
					<Route path={`${props.match.url}/terminals_report`} component={AdminTerminalReportPage} />
					<Route path={`${props.match.url}/devices_report`} component={AdminDeviceReportPage} />
					<Route path={`${props.match.url}/partner_report`} component={AdminPartnerReportPage} />
					<Route path={`${props.match.url}/organization_report`} component={AdminOrganizationReportPage} />
					<Route path={`${props.match.url}/companies_report`} component={AdminCompaniesReportPage} />
					<Route path={`${props.match.url}/transactions_report`} component={AdminTransactionsReportPage} />
					<Route
						path={`${props.match.url}/organization_feature_usage_report`}
						component={AdminOrganizationFeatureUsageReportPage}
					/>
					<Route
						path={`${props.match.url}/organization_feature_report`}
						component={AdminOrganizationFeatureReportPage}
					/>
					<Route path={`${props.match.url}/accesses_report`} component={AdminAccessReportPage} />
					<Redirect from={props.match.url} exact to={`${props.match.url}/`} />
					<Route component={Page404} />
				</Switch>
			</div>
		</>
	);
};

export default AdminReportsPage;
